import type { TFunction } from 'react-i18next';
export const MENU_OPTION = {
  CHANGE_MODEL: 'change_model',
  NEW_CHAT: 'new_chat',
  CLOSE: 'close',
  EXIT_AI_CHAT: 'exit_ai_chat',
} as const;

export const DEFAULT_GRAPH = 'Nexus';
export const DEFAULT_TAG = 'prod';

export const QUERY_PARAM = {
  TAG: 'tag',
  HEADER_LOGO_URL: 'header-logo-url',
  HEADER: 'header',
} as const;

export const FRAME_ACTION = {
  SEND_USER_MESSAGE: 'sendUserMessage',
  CHANGE_GRAPH_CONFIG: 'changeGraphConfig',
} as const;

export const POST_MESSAGE_SOURCE = 'kizen-ai-chat-embed';

export const POST_MESSAGE_EVENT = {
  OPEN_GRAPH_MODEL_CONFIG: 'openGraphModelConfigurationPrompt',
  CLOSE_AI_CHAT: 'closeAiChat',
  COPY_TO_CLIPBOARD: 'copyToClipboard',
  OPEN_WINDOW: 'navigateTo',
} as const;

export const AI_SAMPLE_IDEAS = (t: TFunction) => [
  t('Tell me how to create an Agentic Workflow'),
  t('How can I use Kizen AI to improve my sales process?'),
  t('Create a new custom object'),
  t('Filter my data'),
  t('Add a relationship between objects'),
];
